export default "__VITE_ASSET__CxWS7yn0__"